import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { solutionPoints } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';
export function SolutionSection() {
  return <section aria-labelledby="solution-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-177" data-mp="1joelljkdiquf">
      <div className="mx-auto max-w-5xl" data-id="element-178" data-mp="1oiis61pq8wuz">
        <SectionHeading id="solution-heading" title={<>
              Da lezioni improvvisate <Accent data-id="element-180" data-mp="1ydj4z42wn144">a corsi organizzati.</Accent>
            </>} body="Lash & Brow Instructor Ready™ — Versione Italiana è una raccolta digitale di materiali didattici pensata per aiutarti a strutturare la tua formazione in modo più semplice." data-id="element-179" data-mp="1tg0sx4tlc5rw" />

        <div className="mt-12 grid items-center gap-10 lg:grid-cols-[1.1fr_1fr] lg:gap-14" data-id="element-181" data-mp="905v6zc0wkvm">
          <img src={MOCKUP_URL} alt="Il sistema completo Lash & Brow Instructor Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[560px] object-contain" style={{
          filter: 'drop-shadow(0 30px 36px rgba(180, 86, 111, 0.16))'
        }} data-id="element-182" data-mp="d0zhjo9thrme" />

          <div data-id="element-183" data-mp="3i2yckhhu4eyc">
            <p className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-gold" data-id="element-184" data-mp="3i3gffwz05rf8">
              Con questo sistema puoi
            </p>
            <ul className="mt-5 space-y-4" role="list" data-id="element-185" data-mp="jj86rwwf8afu">
              {solutionPoints.map(point => <li key={point} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal sm:text-[16px]" data-id="element-186" data-mp="ek4y82h8fm34">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-187" data-mp="4oabav5z74uj" />
                  {point}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}